export var DEFAULT_CHAR_LIMIT = 300;
export var DEFAULT_CHAR_OFFSET = 50;